import React, { useEffect, useState } from "react";
import { FaBars, FaBell, FaHome, FaUser } from "react-icons/fa";
import { GrDown, GrLogin, GrUp } from "react-icons/gr";
import { Link, Outlet } from "react-router-dom";
import { Icon, } from "@mui/material";
import Logo from '../../../../assets/Images/logo-ethics.png';
import { Layers } from "@mui/icons-material";
import Popup from "reactjs-popup";
import AddClient from "../../ClientMaster/AddClient";
import ResetPassword from "./ResetPassword";
interface LoginProps {
  onLogOut: (user: any) => void; // Define the type of onLogin function
}

interface ResetPasswordForm {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}


const Sidebar: React.FC<LoginProps> = ({ onLogOut }) => {
  const [isHidden, setIsHidden] = useState(false);
  const [isFull, setIsFull] = useState(false);
  const [userMenu, setUserMenu] = useState([]);
  const [appUserName, setAppUser] = useState<string>('');
  const [menuData, setMenuData] = useState<any[]>([
    {
      Id: 1,
      ParentId: 0,
      Title: "Client Master",
      Link: "ClientMaster",
      Icon: "Layers",
      children: null
    },
    {
      Id: 2,
      ParentId: 0,
      Title: "Report",
      Link: null,
      Icon: "blur_on",
      children: [
        {
          Id: 3,
          ParentId: 2,
          Title: "Product Detail",
          Link: "ProductReport",
          Icon: "layers",
          children: null
        }
      ]
    },
    {
      Id: 4,
      ParentId: 0,
      Title: "Reset Password",
      Link: "",
      Icon: "Layers",
      children: null,
      Action: "OPEN_MODAL"
    }
  ]);



  const toggleMenu = () => {
    localStorage.setItem('isHidden', String(!isHidden));
    setIsHidden(!isHidden);
    setIsFull(!isFull);
  };

  const navigateToPage = (path: any) => {
    // HERE WRITW A CODE TO NAVIGATE COMPENNET IN REACT TS
  }


  useEffect(() => {
    const fetchUserMenudata = async () => {
      // debugger
      let userMenudata1;
      //let userMenudata1 = JSON.parse(localStorage.getItem('user'));
      const userFromStorage = localStorage.getItem('user');
      if (userFromStorage !== null) {
        userMenudata1 = JSON.parse(userFromStorage);
      }

      userMenudata1?.usermenu !== undefined && setUserMenu(JSON.parse(userMenudata1.usermenu));
      userMenudata1?.userName !== undefined && setAppUser(userMenudata1.userName);

    }

    fetchUserMenudata();

  }, []);

  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const toggleSubMenu = (itemId: any) => {
    setActiveSubMenu(itemId === activeSubMenu ? null : itemId);
  };
  const [open, setOpen] = React.useState(true);
  const [showModal, setShowModal] = useState(false);
  return (
    <>

      <div className="dash">

        {/* <nav className={`sidebar ${isHidden ? 'hidden' : ''}`} style={`@media (max-width:750px) {  ${isHidden ? '.sidebar {display: none;}': '.sidebar {display: block;}'}`}>
                     */}
        {/* <nav className={`sidebar ${isHidden ? 'hidden' : ''}`} > */}
        <nav className={`sidebar ${isHidden ? 'hidden' : ''}`}>
          <div className="head-logo-content">

            <div className="logo">
              <img src={Logo} height="40"></img>&nbsp; &nbsp;
            </div>
            <div>
              <span className="logo-name">{appUserName}</span>
            </div>
          </div>
          <hr className="head-hr" />
          <ul>
            {menuData.map((item: any) => {
              return (

                <li key={item.Id} >
                  {item.children === null ? <div style={{ padding: 4, paddingLeft: 8, marginLeft: 15 }}> <Link to={item.Link} onClick={(e) => {
                    if (item.Action === "OPEN_MODAL") {
                      e.preventDefault();
                      setShowModal(true);
                    }
                  }} style={{ padding: 0 }}><span className="li-content"><div><Layers />&nbsp;&nbsp;</div><div style={{ marginTop: -0.5 }}>{item.Title}</div></span></Link></div> :
                    <>
                      <div onClick={() => toggleSubMenu(item.Id)} style={{ marginLeft: 25, cursor: 'pointer' }}>
                        <span key={item.Id} className="li-content1 "><div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center' }}><Layers /> &nbsp;&nbsp;<div style={{ marginTop: -0.5 }}>{item.Title}</div></div><div>

                          {activeSubMenu === item.Id ? <GrUp /> : <GrDown />}
                        </div></span>
                      </div>
                      {item.children && (
                        <ul className={activeSubMenu === item.Id ? 'submenu active' : 'submenu'}>

                          {item.children.map((child: any) => (
                            <div key={child.Id} className="submemnu-content">
                              <Link to={child.Link} style={{ padding: 2 }} >
                                <li style={{ cursor: 'pointer', marginLeft: 25, marginTop: 5 }}><span className="li-content "><div><Layers /> &nbsp;&nbsp;</div>{child.Title}</span></li></Link>
                            </div>
                          ))}
                        </ul>
                      )}
                    </>
                  }
                </li>
              )
            })}
          </ul>
          <ul>

            {userMenu.map((item: any) => {
              return (

                <li key={item.Id} >
                  {item.children === null ? <div style={{ padding: 4, paddingLeft: 8 }}> <Link to={item.Link} style={{ padding: 0 }}><span className="li-content"><div><Icon>{item.Icon}</Icon>&nbsp;&nbsp;</div><div style={{ marginTop: -0.5 }}>{item.Title}</div></span></Link></div> :
                    <>
                      <div onClick={() => toggleSubMenu(item.Id)} style={{ marginLeft: 10, cursor: 'pointer' }}>
                        <span key={item.Id} className="li-content1 "><div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center' }}><Icon>{item.Icon}</Icon> &nbsp;&nbsp;<div style={{ marginTop: -0.5 }}>{item.Title}</div></div><div>

                          {activeSubMenu === item.Id ? <GrUp /> : <GrDown />}
                        </div></span>
                      </div>
                      {item.children && (
                        <ul className={activeSubMenu === item.Id ? 'submenu active' : 'submenu'}>

                          {item.children.map((child: any) => (
                            <div key={child.Id} className="submemnu-content">
                              <Link to={child.Link} style={{ padding: 2 }} >
                                <li style={{ cursor: 'pointer' }}><span className="li-content "><div><Icon>{child.Icon}</Icon> &nbsp;&nbsp;</div>{child.Title}</span></li></Link>
                            </div>
                          ))}


                        </ul>
                      )}
                    </>
                  }
                </li>
              )
            })}

          </ul>
        </nav>
        <div className={`head ${isHidden ? 'full' : ''}`}>
          <div>
            <div className="head-content">
              <div>
                <button className="toggle-button" onClick={toggleMenu}><FaBars /></button>&nbsp;&nbsp;
                <Link to="/" ><button className="toggle-button" ><FaHome /></button></Link>
              </div>
              <div >

                <button className="toggle-button" onClick={toggleMenu}><FaUser /></button>&nbsp;
                <button className="toggle-button" onClick={toggleMenu}><FaBell /></button>&nbsp;
                <button className="toggle-button" onClick={onLogOut}><GrLogin /></button>&nbsp;
              </div>
            </div>
            <div className="main-content">
              <Outlet />


            </div>

          </div>

        </div>


      </div>

      {showModal && (
        <ResetPassword
          open={showModal}
          onClose={() => setShowModal(false)}
        />
      )}

    </>
  );
}

export default Sidebar;
